import { Filters, FiltersPagination } from '@/types';
import { ResponseStatuses } from '@/enums';
import { AxiosResponse } from 'axios';
import { Actions } from 'vuex-smart-module';
import { DispatchesService } from '../services';
import { DownloadFilters } from '../types';
import DispatchesGetters from './getters';
import DispatchesMutations from './mutations';
import DispatchesState from './state';

const DispatchService = new DispatchesService();

export default class DispatchesActions extends Actions<
  DispatchesState,
  DispatchesGetters,
  DispatchesMutations,
  DispatchesActions
> {
  async get_dispatches(storage_limit?: number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;
      const payload: FiltersPagination<Filters> = {
        filters: this.state.filters,
        pagination: {
          limit: storage_limit ?? itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_DISPATCHES(true);
      const { data, meta } = await DispatchService.get_dispatches(payload);

      this.mutations.SET_DISPATCHES(data.items);
      this.mutations.SET_USER_ORGANIZATIONS(data.organizations);
      this.mutations.SET_EXTERNAL_ORGANIZATIONS(data.organizations_external);
      this.mutations.SET_CONTRACTS(data.contracts);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.log(error);
    } finally {
      this.mutations.TOGGLE_LOADING_DISPATCHES(false);
    }
  }

  async get_dispatches_download() {
    try {
      const filtersEmpty = Boolean(this.state.categories.length && this.state.products.length);

      const payload: DownloadFilters = {
        filters: this.state.filters_download,
        filters_exist: filtersEmpty,
      };

      const { data } = await DispatchService.get_dispatches_download(payload);

      if (!filtersEmpty) {
        this.mutations.SET_CATEGORIES(data.categories);
        this.mutations.SET_PRODUCTS(data.products);
      }

      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  async get_dispatch_by_id(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await DispatchService.get_dispatch_by_id(
        id,
      );

      this.mutations.SET_DISPATCH_DETAILS(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_dispatch_corrective_by_id(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await DispatchService.get_dispatch_corrective_by_id(
        id,
      );

      this.mutations.SET_DISPATCH_CORRECTIVE(data);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_dispatch_return(id: string | number) {
    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await DispatchService.get_dispatch_return(
        id,
      );

      this.mutations.SET_DISPATCH_RETURNS(data.items);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async send_dispatch_return(payload: {id: number | string, form_data: FormData}) {
    const { id, form_data } = payload;

    try {
      const { data, code = ResponseStatuses.Fail.FORBIDDEN } = await DispatchService.send_dispatch_return(
        id, form_data,
      );

      this.mutations.SET_DOCUMENTS_DATA_DIALOG(data.documents || []);
      return code;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }

  async get_dispatch_as_document(id: string | number) {
    try {
      const { data, success } = await DispatchService.get_dispatch_as_documents(id);

      this.mutations.SET_DISPATCH_DOCUMENT_LINK(data);
      return success;
    } catch (error) {
      console.log(error);
      return (error as AxiosResponse).status;
    }
  }
}
